import * as React from "react";

import { Button, Grid, Table, Loader } from "semantic-ui-react";

import { useSelector } from "react-redux";

import { pathSelector, employeeRecordIdSelector } from "../selectors";

import {
    OccupationalIllnessCategory,
    OccupationalIllnessListModel,
    OccupationalIllness
} from "../models";

import { OccupationalIllnessApi } from "../occupationalIllnessApi";

import { Create } from "./Create";

import { Fragment, Link } from "redux-little-router";

export const AllOccupationalIllnessRecords: React.FunctionComponent = () => {
    const path = useSelector(pathSelector);
    const employeeRecordId = useSelector(employeeRecordIdSelector);

    const [loading, setLoading] = React.useState<boolean>(true);
    const [occupationalIllnesses, setOccupationalIllnesses] = React.useState<OccupationalIllnessListModel[]>();

    React.useEffect(() => {
        (async () => {
            setLoading(true);
            const records = await OccupationalIllnessApi.getAll(employeeRecordId);
            const recordsList: OccupationalIllnessListModel[] = records.map(r => ({
                id: r.id,
                diagnosedOrSuspected: r.diagnosedOrSuspected,
                injuryOrIllness: r.injuryOrIllness,
                linkedOhCaseId: r.ohCase?.name,
                oshaReportable: r.oshaReportable,
                riddorReportable: r.riddorReportable,
                category: r.category
            }));
            setOccupationalIllnesses(recordsList);
            setLoading(false);
        })();
    }, []);

    const onNewOccupationalIllnessCreated = (oi: OccupationalIllness) => {
        const newOccupationalIllnessListModel: OccupationalIllnessListModel = {
            id: oi.id,
            diagnosedOrSuspected: oi.diagnosedOrSuspected,
            injuryOrIllness: oi.injuryOrIllness,
            linkedOhCaseId: oi.ohCase?.name,
            oshaReportable: oi.oshaReportable,
            riddorReportable: oi.riddorReportable,
            category: oi.category
        };
        setOccupationalIllnesses([...occupationalIllnesses, newOccupationalIllnessListModel]);
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row >
                    <Grid.Column width={6}>
                        <h1>Occupational Illness Records</h1>
                    </Grid.Column>
                    <Grid.Column width={10} textAlign="right">
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Category</Table.HeaderCell>
                                    <Table.HeaderCell>Diagnosed or Suspected</Table.HeaderCell>
                                    <Table.HeaderCell>Injury or Illness</Table.HeaderCell>
                                    <Table.HeaderCell>Linked to OH Case</Table.HeaderCell>
                                    <Table.HeaderCell>OSHA Reportable</Table.HeaderCell>
                                    <Table.HeaderCell>RIDDOR Reportable</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {occupationalIllnesses && occupationalIllnesses.map(occupationalIllness => (
                                    <Table.Row key={occupationalIllness.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${occupationalIllness.id}`}>
                                                {OccupationalIllnessCategory[occupationalIllness.category]}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {occupationalIllness.diagnosedOrSuspected}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {occupationalIllness.injuryOrIllness}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {occupationalIllness.linkedOhCaseId}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {occupationalIllness.oshaReportable ? "Yes" : "No"}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {occupationalIllness.riddorReportable ? "Yes" : "No"}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Fragment forRoute="/create">
                <Create onCreated={onNewOccupationalIllnessCreated} />
            </Fragment>
        </>
    );
};
